// extracted by mini-css-extract-plugin
export var csatScore = "_l2-5";
export var header = "_l2-1";
export var panelWrapper = "_l2-2";
export var postPreview = "_l2-3";
export var rightContent = "_l2-0";
export var wrappingText = "_l2-4";